import { useQuery } from "@tanstack/react-query";
import { IPricingApi } from "@/api/pricing";
import { SERVICES_TYPES, useInjection } from "@/ioc";

export const useMetaRates = () => {
  const pricingApi = useInjection<IPricingApi>(SERVICES_TYPES.PRICING);

  return useQuery({
    queryKey: ["meta-rates"],
    queryFn: () => pricingApi.getRates()
  });
};
